import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Erro ao enviar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg p-6">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-slate-100 p-8 sm:p-10">
        <Logo />
        {sent ? (
          <div className="mt-8 text-center">
            <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center mx-auto"><MailCheck className="w-7 h-7 text-brand-green" /></div>
            <h1 className="mt-5 font-heading text-2xl font-black text-brand-ink">Verifique seu e-mail</h1>
            <p className="mt-2 text-brand-muted text-sm">Se houver uma conta com este e-mail, enviamos um link para redefinir sua senha.</p>
            <Link to="/login"><Button className="mt-6 rounded-full bg-brand-blue hover:bg-blue-700">Voltar ao login</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="mt-8 font-heading text-2xl font-black text-brand-ink">Recuperar senha</h1>
            <p className="mt-2 text-brand-muted text-sm">Informe seu e-mail e enviaremos um link de redefinição.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">E-mail</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 rounded-xl h-11" data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={loading} className="w-full rounded-full h-12 bg-brand-blue hover:bg-blue-700 font-semibold" data-testid="forgot-submit">
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Enviar link"}
              </Button>
            </form>
            <Link to="/login" className="mt-6 block text-center text-sm text-brand-muted hover:text-brand-ink">Voltar ao login</Link>
          </>
        )}
      </div>
    </div>
  );
}
